import React, { useState } from 'react';
import login_logo from '../../../assets/images/login_logo_web.png';
import Card from '@mui/material/Card';
import { Box, Input, Typography, Button, IconButton, Checkbox, FormControlLabel } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const ariaLabel = { 'aria-label': 'description' };

const Login = () => {
  const [checked, setChecked] = useState(false); 
  const [loading, setLoading] = useState(false); 
  const navigate = useNavigate(); 

  
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success('Copied to clipboard!');
    });
  };

 
  const initialValues = {
    email: '',
    password: '',
  };

  
  const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email address').required('Email is required'),
    password: Yup.string().min(8, 'Password must be at least 8 characters').required('Password is required'),
  });

  const handleSubmit = async (values) => {
    setLoading(true);
  
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/user/admin/login`, {
        email: values.email,
        password: values.password,
      });
  
      if (response.status === 200) {
        const { message, token, username,adminId } = response.data; 
  
        if (message && token && username && adminId) {
          localStorage.setItem('authToken', token);
          localStorage.setItem('username', username);
          localStorage.setItem('adminId', adminId);    
  
          toast.success('Login successful!');
          navigate('/');
        } else {
          toast.error('Login failed. Please check your credentials.');
        }
      } else {
        toast.error('An error occurred during login. Please try again.');
      }
    } catch (error) {
      if (error.response) {
        toast.error(`Error: ${error.response.data.message || 'An error occurred. Please try again.'}`);
      } else if (error.request) {
        toast.error('No response from the server. Please check your network connection.');
      } else {
        toast.error('An unexpected error occurred. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };
  
  
  

  return (
    <div className='bg-green login-con-cls'>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
        <div className='login-logo-cls'>
          <img src={login_logo} alt="Login logo" />
        </div>

        {/* Login Card */}
        <Card sx={{ p: 2 }} className='login-card-cls' mb={3}>
          <Typography sx={{ mb: '25px', color: '#67757c' }} component="p" variant="body1">
            Login
          </Typography>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ setFieldValue, values, touched, errors }) => (
              <Form>
                <Field
                  name="email"
                  as={Input}
                  sx={{ my: '10px', width: '100%' }}
                  placeholder="Email"
                  inputProps={ariaLabel}
                  value={values.email}
                  onChange={(e) => setFieldValue('email', e.target.value)}
                  required
                  error={touched.email && Boolean(errors.email)}
                />
                <ErrorMessage name="email" component="div" style={{ color: 'red' }} />
                <Field
                  name="password"
                  as={Input}
                  sx={{ my: '10px', width: '100%' }}
                  placeholder="Password"
                  inputProps={ariaLabel}
                  type="password"
                  value={values.password}
                  onChange={(e) => setFieldValue('password', e.target.value)}
                  required
                  error={touched.password && Boolean(errors.password)}
                />
                <ErrorMessage name="password" component="div" style={{ color: 'red' }} />

                <FormControlLabel
                  sx={{ justifyContent: 'center', my: '10px', width: '100%' }}
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={handleChange}
                      name="rememberMe"
                      color="primary"
                    />
                  }
                  label="Remember me"
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ my: 2, p: 2, bgcolor: "#3c7f06", width: '100%' }}
                  disabled={loading} // Disable the button while loading
                >
                  {loading ? 'Logging in...' : 'Login'}
                </Button>
              </Form>
            )}
          </Formik>

          {/* Email and Password Copy Card */}
          <Card sx={{ p: 2, m: 2, boxShadow: '0 0px 6px 0px rgba(0, 0, 0, 0.5)' }} className='copy-card-cls'>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="body1" sx={{ mr: 2, color: '#000', fontWeight: 600 }}>
                Email: admin@ebasket.com
              </Typography>
              <IconButton onClick={() => handleCopy("admin@ebasket.com")} aria-label="copy email">
                <FileCopyIcon fontSize="small" sx={{ color: "#3c7f06" }} />
              </IconButton>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant="body1" sx={{ mr: 2, color: '#000', fontWeight: 600 }}>
                Password: 12345678
              </Typography>
              <IconButton onClick={() => handleCopy("12345678")} aria-label="copy password">
                <FileCopyIcon fontSize="small" sx={{ color: "#3c7f06" }} />
              </IconButton>
            </Box>
          </Card>
        </Card>
      </Box>
    </div>
  );
};

export default Login;
